import * as _ from "lodash";
import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let ColumnsDialogComponent = {
    selector: "vcColumnsDialog",
    templateUrl: "/angular/components/table/columns-dialog.component.html",
    bindings: {
        columns: "=?",
        sortable: "=?",
        /** Optional: pass the defaults to offer a Reset button. */
        defaults: "<?",
    },
    controller: class ColumnsDialogController {
        // * bindings for typescript compiler *
        public columns?: any;
        public sortable?: any;
        public defaults?: any;
        // ************************************

        private dialog: DialogUtils;
        public columnsCopy;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.columnsCopy = _.cloneDeep(this.columns);
        }

        reset(): void {
            this.columnsCopy = _.cloneDeep(this.defaults);
        }

        confirm(columns): void {
            this.dialog.hide(columns);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("table", [])
    .component(ColumnsDialogComponent.selector, ColumnsDialogComponent);
